import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import FeaturedProducts from './components/FeaturedProducts';
import QualityGuarantee from './components/QualityGuarantee';
import HowItWorks from './components/HowItWorks';
import CountriesSection from './components/CountriesSection';
import IndustriesServed from './components/IndustriesServed';
import LegacySection from './components/LegacySection';
import TestimonialsSection from './components/TestimonialsSection';
import WhyUsSection from './components/WhyUsSection';
import ShippingPortsSection from './components/ShippingPortsSection';
import FAQSection from './components/FAQSection';
import CaseStudyBanner from './components/CaseStudyBanner';
import BlogSection from './components/BlogSection';
import FooterSection from './components/FooterSection';
import QuotePopup from './components/QuotePopup';
import WhatsAppButton from '@/components/feature/WhatsAppButton';

export default function HomePage() {
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <div className="min-h-screen font-sans">
      <Navbar onQuoteClick={() => setQuoteOpen(true)} />
      <HeroSection onQuoteClick={() => setQuoteOpen(true)} />
      <TrustBar />
      <FeaturedProducts />
      <WhyUsSection />
      <QualityGuarantee />
      <HowItWorks />
      <CaseStudyBanner />
      <CountriesSection />
      <ShippingPortsSection />
      <IndustriesServed onQuoteClick={() => setQuoteOpen(true)} />
      <LegacySection />
      <TestimonialsSection />
      <FAQSection />
      <BlogSection />
      <FooterSection />
      <WhatsAppButton />
      {quoteOpen && <QuotePopup onClose={() => setQuoteOpen(false)} />}
    </div>
  );
}
